import { j as p, c as x } from "../../utils-BdNIfrGQ.js";
import { t as g } from "../../BaseTypography.styles-D7he6cFf.js";
import { n as h } from "../../normalize-spacing-DY0KSpr_.js";
import { H as b } from "../../H2-CGvOaVnq.js";
import { H as F } from "../../H3-Bopq07l-.js";
import { P as T } from "../../Paragraph-Cpgi01iq.js";
import { T as E } from "../../Text-BhLXzYEf.js";
import { P as S } from "../../Pre-D04-y4ZY.js";
const j = (r) => {
  const {
    align: t = "left",
    size: o = "3xl",
    variant: a,
    fontWeight: e = "bold",
    modifier: s,
    truncate: i,
    color: n,
    fontFamily: m,
    spacing: c,
    children: f,
    ...l
  } = r;
  return /* @__PURE__ */ p.jsx(
    "h1",
    {
      className: x(
        g({
          variant: a,
          align: t,
          size: o,
          fontWeight: e,
          modifier: s,
          truncate: i,
          color: n,
          fontFamily: m
        }),
        h(c)
      ),
      ...l,
      children: f
    }
  );
}, y = (r) => {
  const {
    align: t = "left",
    size: o,
    variant: a,
    fontWeight: e = "semibold",
    modifier: s,
    truncate: i,
    color: n,
    fontFamily: m,
    spacing: c,
    children: f,
    ...l
  } = r;
  return /* @__PURE__ */ p.jsx(
    "h4",
    {
      className: x(
        g({
          variant: a,
          align: t,
          size: o,
          fontWeight: e,
          modifier: s,
          truncate: i,
          color: n,
          fontFamily: m
        }),
        h(c)
      ),
      ...l,
      children: f
    }
  );
};
export {
  j as H1,
  b as H2,
  F as H3,
  y as H4,
  T as Paragraph,
  S as Pre,
  E as Text
};
